import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import { ACL_ENTITIES, DASHBOARD_RESOURCES, Entity, PAGE_NAMES } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import AuthorizedRouteACL from 'commons-ui/src/permission/AuthorizedRoute';
import DashboardHome from './DashboardHome';
import { URL, COMPONENT } from './helper';

const Dashboard: React.FC<{}> = () => {
	const [css] = useStyletron();
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<div className={css({ height: 'calc(100% - 110px)' })}>
				<Switch>
					<AuthorizedRoute
						exact
						configPageName={PAGE_NAMES.dashboard}
						path={`/${PAGE_NAMES.dashboard}`}
						component={DashboardHome}
					/>
					{_map(_values(DASHBOARD_RESOURCES), (entity: Entity) => {
						if (ACL_ENTITIES.includes(entity)) {
							return (
								<AuthorizedRouteACL
									key={entity}
									configPageName={PAGE_NAMES.dashboard}
									configResourceName={entity}
									component={COMPONENT[entity]}
									path={URL[entity]}
								/>
							);
						}
						return (
							<AuthorizedRoute
								key={entity}
								configPageName={PAGE_NAMES.dashboard}
								entity={entity}
								path={URL[entity]}
								component={COMPONENT[entity]}
							/>
						);
					})}
					<Redirect to={`/${PAGE_NAMES.dashboard}`} />
				</Switch>
			</div>
		</>
	);
};

export default Dashboard;
